import { render, staticRenderFns } from "./checkRadioGroupNew.vue?vue&type=template&id=59664d9d&scoped=true"
import script from "./checkRadioGroupNew.vue?vue&type=script&lang=js"
export * from "./checkRadioGroupNew.vue?vue&type=script&lang=js"
import style0 from "./checkRadioGroupNew.vue?vue&type=style&index=0&id=59664d9d&prod&lang=scss&scoped=true"
import style1 from "./checkRadioGroupNew.vue?vue&type=style&index=1&id=59664d9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59664d9d",
  null
  
)

export default component.exports